import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { loadClassicPage, loadLayoutPage } from './core/utils/layout-page-loader';
import { relatoriosV2TemplatesRedirectGuard } from './core/guards/relatorios-v2-redirect.guard';
import { loadRelatoriosHistoryPage, loadRelatoriosPage } from './core/utils/relatorios-page-loader';

export const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
    {
        path: 'entrar',
        loadComponent: loadLayoutPage(
            () => import('./pages/login/login'),
            'Login',
            () => import('./_layout_v2/pages/login/login'),
        ),
        data: { fullPage: true },
    },
    {
        path: 'recuperar-senha',
        loadComponent: loadLayoutPage(
            () => import('./pages/recuperar-senha/recuperar-senha'),
            'RecuperarSenha',
            () => import('./_layout_v2/pages/recuperar-senha/recuperar-senha'),
        ),
        data: { fullPage: true },
    },
    {
        path: 'redefinir-senha/:token',
        loadComponent: loadLayoutPage(
            () => import('./pages/redefinir-senha/redefinir-senha'),
            'RedefinirSenha',
            () => import('./_layout_v2/pages/redefinir-senha/redefinir-senha'),
        ),
        data: { fullPage: true },
    },
    {
        path: 'dashboard',
        canActivate: [authGuard],
        loadComponent: loadLayoutPage(
            () => import('./pages/dashboard/dashboard'),
            'Dashboard',
            () => import('./_layout_v2/pages/dashboard/dashboard'),
        ),
        data: { breadcrumb: 'Dashboard' },
    },
    {
        path: 'quadros',
        canActivate: [authGuard],
        data: { breadcrumb: 'Quadros' },
        children: [
            {
                path: 'analitico',
                data: { breadcrumb: 'Analítico' },
                loadComponent: loadLayoutPage(
                    () => import('./pages/quadros/analitico/analitico'),
                    'Analitico',
                    () => import('./_layout_v2/pages/quadros/analitico/analitico'),
                ),
            },
            {
                path: 'eventos',
                data: { breadcrumb: 'Eventos' },
                loadComponent: loadLayoutPage(
                    () => import('./pages/quadros/eventos/eventos'),
                    'Eventos',
                    () => import('./_layout_v2/pages/quadros/eventos/eventos'),
                ),
            },
        ],
    },
    {
        path: 'eventos',
        canActivate: [authGuard],
        data: { breadcrumb: 'Eventos' },
        children: [
            {
                path: 'novo',
                data: { breadcrumb: 'Novo' },
                loadComponent: loadLayoutPage(
                    () => import('./pages/eventos/novo-evento/novo-evento'),
                    'NovoEvento',
                    () => import('./_layout_v2/pages/eventos/novo-evento/novo-evento'),
                ),
            },
            {
                path: 'relatorios/templates/editar/:id',
                canActivate: [relatoriosV2TemplatesRedirectGuard],
                data: { breadcrumb: 'Editar Template' },
                loadComponent: loadClassicPage(
                    () => import('./pages/eventos/relatorios/templates/templates-form'),
                    'TemplatesForm',
                ),
            },
            {
                path: 'relatorios/templates/novo',
                canActivate: [relatoriosV2TemplatesRedirectGuard],
                data: { breadcrumb: 'Novo Template' },
                loadComponent: loadClassicPage(
                    () => import('./pages/eventos/relatorios/templates/templates-form'),
                    'TemplatesForm',
                ),
            },
            {
                path: 'relatorios/templates',
                pathMatch: 'full',
                canActivate: [relatoriosV2TemplatesRedirectGuard],
                data: { breadcrumb: 'Templates' },
                loadComponent: loadClassicPage(
                    () => import('./pages/eventos/relatorios/templates/templates-list'),
                    'TemplatesList',
                ),
            },
            {
                path: 'relatorios/builder',
                data: { breadcrumb: 'Gerar relatório' },
                loadComponent: loadRelatoriosPage(
                    () => import('./pages/eventos/relatorios/relatorios-eventos'),
                    'RelatoriosEventos',
                    () => import('./features/relatorios/pages/builder/report-builder.component'),
                    'ReportBuilder',
                ),
            },
            {
                path: 'relatorios',
                pathMatch: 'full',
                data: { breadcrumb: 'Consulta' },
                loadComponent: loadRelatoriosPage(
                    () => import('./pages/eventos/relatorios/templates/templates-list'),
                    'TemplatesList',
                    () => import('./features/relatorios/pages/hub/relatorios-hub.component'),
                    'RelatoriosHub',
                ),
            },
        ],
    },
    {
        path: 'hinova',
        canActivate: [authGuard],
        data: { breadcrumb: 'Hinova' },
        children: [
            {
                path: '',
                loadComponent: loadLayoutPage(
                    () => import('./pages/hinova/hinova'),
                    'Hinova',
                    () => import('./_layout_v2/pages/hinova/hinova'),
                ),
            },
            {
                path: 'diagnostico',
                data: { breadcrumb: 'Diagnóstico' },
                loadComponent: loadLayoutPage(
                    () => import('./pages/hinova/diagnostico/diagnostico-panel.component'),
                    'DiagnosticoPanelComponent',
                    () => import('./_layout_v2/pages/hinova/diagnostico/diagnostico-panel.component'),
                ),
            },
            {
                path: 'estados-cidades',
                pathMatch: 'full',
                redirectTo: '/estados-cidades',
            },
        ],
    },
    {
        path: 'fornecedores',
        canActivate: [authGuard],
        data: { breadcrumb: 'Fornecedores' },
        children: [
            {
                path: '',
                loadComponent: loadLayoutPage(
                    () => import('./pages/fornecedores/list/fornecedores'),
                    'Fornecedores',
                    () => import('./_layout_v2/pages/fornecedores/list/fornecedores'),
                ),
            },
            {
                path: 'novo',
                data: { breadcrumb: 'Novo' },
                loadComponent: loadLayoutPage(
                    () => import('./pages/fornecedores/novo/fornecedores-novo'),
                    'FornecedoresNovo',
                    () => import('./_layout_v2/pages/fornecedores/novo/fornecedores-novo'),
                ),
            },
            {
                path: ':id',
                data: { breadcrumb: 'Detalhe' },
                loadComponent: loadLayoutPage(
                    () => import('./pages/fornecedores/detalhe/fornecedores-detalhe'),
                    'FornecedoresDetalhe',
                    () => import('./_layout_v2/pages/fornecedores/detalhe/fornecedores-detalhe'),
                ),
            },
        ],
    },
    {
        path: 'estados-cidades',
        canActivate: [authGuard],
        data: { breadcrumb: 'Estados e Cidades' },
        loadComponent: loadLayoutPage(
            () => import('./pages/hinova/estados-cidades/estados-cidades'),
            'EstadosCidades',
            () => import('./_layout_v2/pages/hinova/estados-cidades/estados-cidades'),
        ),
    },
    {
        path: 'clientes',
        canActivate: [authGuard],
        data: { breadcrumb: 'Clientes' },
        children: [
            {
                path: '',
                loadComponent: loadLayoutPage(
                    () => import('./pages/clientes/list/clientes'),
                    'Clientes',
                    () => import('./_layout_v2/pages/clientes/list/clientes'),
                ),
            },
        ],
    },
    {
        path: 'cliente',
        data: { breadcrumb: 'Consulta de Eventos', fullPage: true },
        loadComponent: loadLayoutPage(
            () => import('./pages/eventos-clientes/eventos-clientes'),
            'EventosClientes',
            () => import('./_layout_v2/pages/eventos-clientes/eventos-clientes'),
        ),
    },
    {
        path: 'configuracoes',
        canActivate: [authGuard],
        data: { breadcrumb: 'Configurações' },
        loadComponent: loadLayoutPage(
            () => import('./pages/configuracoes/configuracoes'),
            'ConfiguracoesPage',
            () => import('./_layout_v2/pages/configuracoes/configuracoes'),
        ),
    },
    {
        path: 'perfil',
        canActivate: [authGuard],
        data: { breadcrumb: 'Meu Perfil' },
        loadComponent: loadLayoutPage(
            () => import('./pages/perfil/perfil'),
            'Perfil',
            () => import('./_layout_v2/pages/perfil/perfil'),
        ),
    },
    {
        path: 'novidades',
        canActivate: [authGuard],
        data: { breadcrumb: 'Novidades' },
        loadComponent: loadLayoutPage(
            () => import('./pages/novidades/novidades'),
            'Novidades',
            () => import('./_layout_v2/pages/novidades/novidades'),
        ),
    },
    {
        path: 'contato',
        canActivate: [authGuard],
        data: { breadcrumb: 'Entre em Contato' },
        loadComponent: loadLayoutPage(
            () => import('./pages/contato/contato'),
            'Contato',
            () => import('./_layout_v2/pages/contato/contato'),
        ),
    },
    {
        path: 'sugestoes',
        canActivate: [authGuard],
        data: { breadcrumb: 'Sugestões' },
        loadComponent: loadLayoutPage(
            () => import('./pages/sugestoes/sugestoes'),
            'Sugestoes',
            () => import('./_layout_v2/pages/sugestoes/sugestoes'),
        ),
    },
    {
        path: 'suporte',
        canActivate: [authGuard],
        data: { breadcrumb: 'Ajuda / Suporte' },
        loadComponent: loadLayoutPage(
            () => import('./pages/suporte/suporte'),
            'Suporte',
            () => import('./_layout_v2/pages/suporte/suporte'),
        ),
    },
    {
        path: 'relatorios',
        canActivate: [authGuard],
        data: { breadcrumb: 'Relatórios' },
        loadComponent: loadRelatoriosHistoryPage(
            () => import('./pages/relatorios/relatorios'),
            'Relatorios',
            () => import('./features/relatorios/pages/history/relatorios-history.component'),
            'RelatoriosHistory',
        ),
    },
    {
        path: 'usuarios',
        canActivate: [authGuard],
        data: { breadcrumb: 'Usuários' },
        children: [
            {
                path: '',
                loadComponent: loadLayoutPage(
                    () => import('./pages/usuarios/list/usuarios-list'),
                    'UsuariosList',
                    () => import('./_layout_v2/pages/usuarios/list/usuarios-list'),
                ),
            },
            {
                path: 'novo',
                data: { breadcrumb: 'Novo' },
                loadComponent: loadLayoutPage(
                    () => import('./pages/usuarios/novo/usuarios-novo'),
                    'UsuariosNovo',
                    () => import('./_layout_v2/pages/usuarios/novo/usuarios-novo'),
                ),
            },
            {
                path: ':id',
                data: { breadcrumb: 'Detalhe' },
                loadComponent: loadLayoutPage(
                    () => import('./pages/usuarios/detalhe/usuarios-detalhe'),
                    'UsuariosDetalhe',
                    () => import('./_layout_v2/pages/usuarios/detalhe/usuarios-detalhe'),
                ),
            },
        ],
    },
    {
        path: 'prazos',
        canActivate: [authGuard],
        data: { breadcrumb: 'Prazos' },
        loadComponent: loadLayoutPage(
            () => import('./pages/prazos/prazos'),
            'PrazosPage',
            () => import('./_layout_v2/pages/prazos/prazos'),
        ),
    },
    {
        path: 'roles',
        canActivate: [authGuard],
        data: { breadcrumb: 'Perfis' },
        children: [
            {
                path: '',
                loadComponent: loadLayoutPage(
                    () => import('./pages/roles/list/roles-list'),
                    'RolesList',
                    () => import('./_layout_v2/pages/roles/list/roles-list'),
                ),
            },
            {
                path: 'novo',
                data: { breadcrumb: 'Novo' },
                loadComponent: loadLayoutPage(
                    () => import('./pages/roles/novo/roles-novo'),
                    'RolesNovo',
                    () => import('./_layout_v2/pages/roles/novo/roles-novo'),
                ),
            },
            {
                path: 'editar/:id',
                data: { breadcrumb: 'Editar' },
                loadComponent: loadLayoutPage(
                    () => import('./pages/roles/novo/roles-novo'),
                    'RolesNovo',
                    () => import('./_layout_v2/pages/roles/novo/roles-novo'),
                ),
            },
        ],
    },
];
